/**
 * Português do Brasil — idioma de origem. Os outros arquivos derivam a tipagem
 * deste, então esquecer uma chave em en/es vira erro de compilação.
 *
 * Preço: o Brasil cobra em real e é o mercado principal. Os arquivos en/es
 * usam moeda e comparativos próprios (ver comentário no topo de cada um).
 */
const landing = {
  seo: {
    title: 'MeuGantt — Software de Gantt e Gestão de Projetos Online',
    description:
      'Gerenciador de projetos online com gráfico de Gantt, Kanban, caminho crítico, EAP e PMBOK 8. Em português, R$ 69/mês para a equipe toda.',
  },

  nav: {
    features: 'Recursos',
    pricing: 'Preços',
    faq: 'FAQ',
    blog: 'Blog',
    login: 'Entrar',
    demo: 'Agendar demo',
    signup: 'Criar Conta Grátis',
    signupSub: 'Sem cartão de crédito',
    menu: 'Menu',
    language: 'Idioma',
  },

  hero: {
    badge: '100% brasileiro, preço em reais, suporte em português',
    titleLead: 'Seus projetos atrasam e',
    titleHighlight: 'ninguém sabe por quê?',
    subtitle:
      'Gerenciador de projetos online com gráfico de Gantt, Kanban, caminho crítico e PMBOK 8, em português, R$ 69/mês para a equipe toda.',
    descLead: 'MeuGantt mostra o caminho crítico, compara planejado vs. real e dá visão executiva de todos os seus projetos, por',
    descHighlight: 'R$ 69/mês para a equipe toda',
    descTail: '. No Monday, seriam R$ 350 para 5 pessoas.',
    ctaPrimary: 'Teste o Professional por 14 dias, grátis',
    ctaSecondary: 'Já tenho conta',
    reassurance: '14 dias grátis com tudo liberado. Depois, plano gratuito para sempre.',
    stats: [
      { value: '67%', label: 'dos projetos atrasam por falta de visibilidade' },
      { value: '52%', label: 'estouram o orçamento sem controle de custos' },
      { value: '80%', label: 'mais barato que Monday para equipe de 5' },
    ],
  },

  painSolution: {
    tag: 'O problema',
    title: 'Você já passou por isso?',
    subtitle:
      'Esses problemas custam tempo, dinheiro e reputação. Veja como o MeuGantt, software de gestão de projetos online em português, resolve cada um.',
    items: [
      { pain: 'Projeto atrasou e ninguém avisou', solution: 'Caminho Crítico automático mostra exatamente onde o atraso impacta a entrega final.' },
      { pain: 'Planejei uma coisa, executei outra', solution: 'Baseline compara o cronograma original com o atual: você vê o desvio em tempo real.' },
      { pain: 'Tenho vários projetos e zero visibilidade', solution: 'Portfólio Executivo consolida KPIs, riscos e progresso de todos os projetos num só painel.' },
      { pain: 'Equipe não sabe quem faz o quê', solution: 'Matriz RACI define papéis claros: quem é Responsável, Aprovador, Consultado e Informado.' },
      { pain: 'Começo do zero todo projeto novo', solution: 'Templates por indústria e IA criam a estrutura completa do projeto em segundos.' },
      { pain: 'Pago R$ 350/mês no Monday para 5 pessoas', solution: 'MeuGantt cobra R$ 69/mês para a equipe toda. Preço fixo, em reais, sem cobrança por cabeça.' },
      { pain: 'Repito as mesmas tarefas no projeto toda semana', solution: 'Conector Claude (MCP): peça em linguagem natural e o Claude cria, atualiza e consulta seu projeto.' },
    ],
  },

  socialProof: [
    { title: 'Produto 100% Brasileiro', desc: 'Desenvolvido no Brasil, para o mercado brasileiro. Interface nativa em PT-BR, sem traduções automáticas.' },
    { title: 'R$ 69 para a equipe toda', desc: 'Sem cobrança por usuário. Equipe de 5 no Monday custa R$ 350/mês. No MeuGantt, R$ 69/mês. Economia de 80%.' },
    { title: 'Nada para instalar', desc: '100% no navegador. Acesse de qualquer lugar, em qualquer dispositivo. Dados na nuvem com backup automático.' },
    { title: 'IA que cria projetos', desc: 'Descreva seu projeto e a IA gera a estrutura completa: fases, tarefas, equipe e cronograma em segundos.' },
  ],

  benefits: {
    support: 'Concorrentes cobram por usuário: para 5 pessoas, Monday sai R$ 350/mês e Asana R$ 340/mês. O MeuGantt entrega controle de projetos online completo, sem cobrança por cabeça.',
    tag: 'Por que trocar?',
    title: 'R$ 69/mês para a equipe toda, no Monday você pagaria R$ 350',
    items: [
      { title: 'Crie seu primeiro Gantt em 2 minutos', desc: 'Sem configuração. Importe do Trello, ClickUp, Azure DevOps ou MS Project, ou use templates prontos por indústria.' },
      { title: 'Saiba antes que o projeto vai atrasar', desc: 'Caminho Crítico automático e Baseline mostram onde está o desvio. Você age antes, não depois.' },
      { title: 'IA gera o projeto inteiro pra você', desc: 'Descreva o projeto em texto livre. A IA cria fases, tarefas, equipe, dependências e cronograma.' },
      { title: 'Migre sem dor de cabeça', desc: 'Importação direta do Trello, ClickUp, Azure DevOps e MS Project. Seus dados vêm junto com hierarquia e dependências.' },
    ],
  },

  showcases: [
    {
      tag: 'Cronograma Gantt',
      title: 'Visualize todo o cronograma do projeto',
      description: 'Gráfico de Gantt interativo com arrastar e soltar, dependências entre tarefas, caminho crítico e linha de hoje em tempo real.',
      bullets: ['Caminho crítico automático', 'Baseline: compare planejado vs. real', 'Dependências entre atividades', 'Arrastar e redimensionar barras'],
    },
    {
      tag: 'Quadro Kanban',
      title: 'Gerencie tarefas de forma visual e ágil',
      description: 'Quadro Kanban com colunas personalizáveis, limites WIP, sprints, labels coloridas e editor de texto rico integrado.',
      bullets: ['Colunas e labels personalizáveis', 'Limites WIP por coluna', 'Sprints com metas e prazos', 'Editor rich text com auto-save'],
    },
    {
      tag: 'Portfólio Executivo',
      title: 'Visão consolidada com EVM em tempo real',
      description: 'Dashboard executivo com KPIs de Valor Agregado (PV/EV/AC), S-curve consolidada, heatmap de capacidade e filtros por status, prioridade e projeto.',
      bullets: ['KPIs EVM consolidados (CV, SV, BAC, EAC)', 'S-curve do portfólio inteiro', 'Heatmap de capacidade da equipe', 'Filtros por status, prioridade e projeto'],
    },
    {
      tag: 'Capacidade da Equipe',
      title: 'Plano, execução e realizado num só painel',
      description: 'Veja quem está sobrecarregado antes de virar burnout. Atenção necessária por recurso, alocação semanal, disponibilidade futura e burn rate de custo da equipe.',
      bullets: ['Atenção necessária e overbooking destacados', 'Alocação semanal e disponibilidade futura', 'Custo da equipe, burn rate em tempo real', 'Filtros por semana, mês e trimestre'],
    },
    {
      tag: 'Conectado com Claude',
      title: 'Automatize tudo conversando com o Claude',
      description: 'Conecte o MeuGantt como Custom Connector no Claude.ai e use linguagem natural para criar projetos, abrir pendências, salvar baseline e consultar EVM. 81 ferramentas, OAuth 2.1 seguro.',
      bullets: ['81 ferramentas acessíveis ao Claude', 'OAuth 2.1: sua conta, suas permissões', 'Claude.ai web e Claude Desktop', 'Disponível em todos os planos'],
    },
  ],

  comparison: {
    sectionTag: 'Comparativo, equipe de 5 pessoas',
    sectionTitle: 'MeuGantt vs. concorrentes',
    sectionSubtitle: 'Para uma equipe de 5 pessoas, você economiza até R$ 281/mês comparado ao Monday. Preço fixo, sem cobrança por cabeça.',
    ctaLabel: 'Testar MeuGantt grátis',
    table: [
      { name: 'MeuGantt', price: 'R$ 69/mês', priceNote: 'até 5 membros' },
      { name: 'Monday', price: 'R$ 350/mês', priceNote: '5 usr × R$70' },
      { name: 'Asana', price: 'R$ 340/mês', priceNote: '5 usr × R$68' },
      { name: 'ClickUp', price: 'R$ 250/mês', priceNote: '5 usr × R$50' },
      { name: 'Trello', price: 'R$ 125/mês', priceNote: '5 usr × R$25' },
    ],
    priceLabel: '/mês',
    competitors: [
      { name: 'Monday.com', price: 'R$ 350', note: '5 usuários × R$ 70' },
      { name: 'Asana', price: 'R$ 340', note: '5 usuários × R$ 68' },
    ],
    us: { name: 'MeuGantt', price: 'R$ 69', note: 'até 5 membros, preço fixo' },
    featureHeader: 'Recurso',
    rows: [
      'Conector Claude (MCP)', 'EVM completo (PMBOK)', 'Gantt Interativo', 'Caminho Crítico',
      'Baseline (planejado vs. real)', 'EAP / WBS Visual', 'Matriz RACI', 'Gestão de Riscos',
      'Controle de Custos', 'Portfólio Executivo', 'Kanban com Sprints', 'Criação com IA',
      'Templates por Indústria', 'Interface nativa PT-BR', 'Preço em Reais (BRL)',
    ],
  },

  testimonials: {
    sectionTag: 'DEPOIMENTOS',
    sectionTitle: 'O MeuGantt em primeira pessoa',
    sectionSubtitle: 'De quem usa, de quem construiu. As palavras de cada um sobre o que move o MeuGantt no dia a dia dos projetos.',
    trustTitle: 'Por que dá pra confiar',
    trustSubtitle: 'Garantias de quem está por trás do produto',
    trust: [
      { title: 'Construído por dois PMP', desc: 'Fundadores com certificação PMI, experiência em PMO e gestão de portfólio. Quem desenha o produto sabe do que ele faz.' },
      { title: 'Alinhado ao PMBoK 8', desc: 'EAP, RACI, baseline, caminho crítico e gestão de riscos seguindo o padrão internacional do PMI.' },
      { title: 'Suporte humano em português', desc: 'Fale direto com quem desenvolve o produto. Sem chatbot, sem fila internacional.' },
      { title: 'Sem cobrança por usuário', desc: 'Plano único para a equipe toda, sem surpresas na fatura quando o time cresce.' },
    ],
  },

  features: {
    tag: 'Recursos',
    title: 'Tudo para gerenciar seus projetos',
    subtitle: 'Do gráfico de Gantt ao portfólio executivo, todos os módulos em um só lugar.',
    planLabels: { free: 'Gratuito', starter: 'Starter', professional: 'Professional', business: 'Business' },
    items: [
      { title: 'Conector Claude (MCP)', desc: 'Conecte o MeuGantt como Custom Connector no Claude.ai e automatize tarefas conversando. 81 ferramentas via OAuth 2.1, disponível em todos os planos.' },
      { title: 'Gantt Visual', desc: 'Visualize cronogramas com gráficos de Gantt interativos. Arraste, redimensione e acompanhe o progresso.' },
      { title: 'Kanban', desc: 'Gerencie tarefas em quadros Kanban com colunas personalizáveis, limites WIP, sprints e editor rich text.' },
      { title: 'Calendário', desc: 'Veja todas as atividades em formato de calendário mensal, semanal ou diário.' },
      { title: 'Central de Ajuda', desc: 'Wiki integrada para documentação do projeto. Organize o conhecimento da equipe.' },
      { title: 'Cronograma', desc: 'Tabela completa de atividades com durações, dependências e caminho crítico.' },
      { title: 'Pendências', desc: 'Gerencie tarefas pendentes com prioridades, responsáveis e prazos.' },
      { title: 'Matriz RACI', desc: 'Defina responsabilidades claras: Responsável, Aprovador, Consultado, Informado.' },
      { title: 'EAP / WBS', desc: 'Estrutura Analítica do Projeto em formato visual hierárquico.' },
      { title: 'Organizações', desc: 'Crie equipes, convide membros por email e compartilhe projetos com sua organização.' },
      { title: 'Templates de Projeto', desc: 'Crie projetos a partir de modelos prontos por indústria: software, marketing, eventos e mais.' },
      { title: 'Baseline de Cronograma', desc: 'Salve o plano original e compare com o cronograma atual. Visualize variações no Gantt.' },
      { title: 'Riscos e Mudanças', desc: 'Registre riscos, avalie impacto e probabilidade. Controle mudanças de escopo.' },
      { title: 'Caminho Crítico', desc: 'Identifique automaticamente a sequência de tarefas que define a duração mínima do projeto.' },
      { title: 'EVM, Valor Agregado', desc: 'S-curve PV/EV/AC/EAC, sparklines SPI/CPI por projeto e snapshot semanal automático. PMBOK 8 puro.' },
      { title: 'Custos e Portfólio', desc: 'Controle orçamentos, acompanhe custos reais vs. planejados. Visão executiva multi-projeto.' },
    ],
  },

  pricing: {
    tag: 'Preços',
    title: 'Planos para todos os tamanhos de projeto',
    subtitle: 'Comece gratuitamente e evolua conforme sua necessidade.',
    monthly: 'Mensal',
    annual: 'Anual',
    discount: '-25%',
    toggleLabel: 'Alternar entre plano mensal e anual',
    perMonth: '/mês',
    currency: 'R$',
    currencyCode: 'BRL',
    savings: 'Economia de R$ {{amount}}/ano',
    mostPopular: 'Mais popular',
    plans: [
      {
        name: 'Free', monthly: 0, annual: 0, desc: 'Para começar a organizar seus projetos', cta: 'Começar Grátis',
        features: ['Até 3 projetos', 'Gantt, Kanban, Calendário, Wiki', 'Minhas Tarefas', 'Até 3 membros por projeto', 'Compartilhamento público', 'Exportação CSV (1/mês)'],
      },
      {
        name: 'Starter', monthly: 69, annual: 52, desc: 'Para a equipe toda (até 5 membros)', cta: 'Assinar Starter',
        features: ['Até 10 projetos', 'Tudo do Free +', 'Organizações (até 5 membros)', 'Cronograma, Pendências, RACI, EAP', 'Templates de Projeto por indústria', 'Baseline de Cronograma', 'Dependências avançadas', 'Exportação CSV ilimitada'],
      },
      {
        name: 'Professional', monthly: 149, annual: 112, desc: 'Para a equipe toda (até 15 membros)', cta: 'Assinar Professional',
        features: ['Projetos ilimitados', 'Tudo do Starter +', 'Organizações (até 15 membros)', 'Riscos, Mudanças, Custos', 'Caminho Crítico automático', 'Portfólio executivo', 'Alocação de Recursos', 'Exportação PDF/PNG', 'Compartilhamento com senha'],
      },
    ],
  },

  faq: {
    tag: 'FAQ',
    title: 'Perguntas frequentes',
    subtitle: 'Tire suas dúvidas sobre o MeuGantt.',
    items: [
      { question: 'Qual a diferença do MeuGantt para Monday, Asana ou ClickUp?', answer: 'MeuGantt oferece Caminho Crítico, Baseline (planejado vs. real), EAP/WBS, Matriz RACI, Gestão de Riscos e Custos, recursos que essas ferramentas não têm ou cobram muito mais caro. Tudo isso por R$ 69/mês, em reais, com interface nativa em português.' },
      { question: 'O MeuGantt é uma plataforma de gestão de projetos online?', answer: 'Sim. MeuGantt é um software de gestão de projetos online (também chamado de programa, plataforma ou gerenciador de projetos) com gráfico de Gantt interativo, Kanban, EAP/WBS, caminho crítico, baseline, riscos e custos. Funciona 100% no navegador, sem instalação, alinhado às boas práticas do PMBOK 8.' },
      { question: 'Serve como sistema de controle de tarefas para empresa?', answer: 'Sim. É uma ferramenta para organizar tarefas da equipe inteira: cada pessoa vê o que precisa fazer, em qual prazo e dependendo do quê. O quadro Kanban e o Gantt compartilham as mesmas tarefas, ideal para controle de tarefas em empresa, agência, escritório ou time interno.' },
      { question: 'O MeuGantt é gratuito?', answer: 'Sim. O plano Free permite até 3 projetos, para sempre, sem cartão de crédito. Inclui Gantt interativo, Kanban, Calendário, Wiki e até 2 membros na organização.' },
      { question: 'Posso importar meus projetos de outra ferramenta?', answer: 'Sim. Importação direta do Trello (JSON), ClickUp (CSV), Azure DevOps (CSV) e Microsoft Project (XML). A estrutura hierárquica e dependências são preservadas.' },
      { question: 'Preciso instalar algum software?', answer: 'Não. MeuGantt funciona 100% no navegador. Acesse de qualquer dispositivo: desktop, tablet ou celular.' },
      { question: 'A IA cria o projeto inteiro mesmo?', answer: 'Sim. Descreva o que precisa em texto livre. A IA gera fases, tarefas, equipe sugerida, dependências e cronograma completo. Disponível nos planos Starter (10/dia) e Professional (30/dia).' },
      { question: 'Meus dados estão seguros?', answer: 'Sim. Infraestrutura Supabase com criptografia em trânsito e em repouso, backups automáticos e autenticação segura. Pagamentos processados via Stripe (PCI-DSS Level 1).' },
      { question: 'Posso compartilhar o cronograma com clientes?', answer: 'Sim, em qualquer plano, inclusive no Free. Gere um link público e a pessoa abre o cronograma sem precisar criar conta. No Professional, proteja com senha e defina expiração do link.' },
      { question: 'Como funciona o pagamento?', answer: 'Pagamento via Stripe com cartão de crédito. Plano mensal ou anual (25% de desconto). Cancelamento a qualquer momento, sem multa.' },
    ],
  },

  cta: {
    title: 'Pare de perder projetos no escuro',
    subtitle: 'Crie seu primeiro Gantt em 2 minutos. 14 dias de Professional grátis, sem cartão.',
    primary: 'Começar meu trial grátis',
    secondary: 'Já tenho conta',
  },

  rail: ['Kickoff', 'Planejamento', 'Execução', 'Controle', 'Automação', 'Go-live'],

  mockups: {
    gantt: {
      aria: 'MeuGantt: gráfico de Gantt com barras, dependências e caminho crítico',
      title: 'Gantt',
      zoom: ['Dias', 'Semanas', 'Meses'],
      colTask: 'Nome da tarefa',
      addTask: 'Adicionar tarefa',
      criticalPath: 'Caminho Crítico',
      colDuration: 'Duração',
      tasks: {
        kickoff: 'Kickoff do projeto',
        requirements: 'Levantamento de requisitos',
        design: 'Desenho da solução',
        setup: 'Configuração do ambiente',
        migration: 'Migração de dados',
        uat: 'Homologação',
        training: 'Treinamento dos usuários',
        golive: 'Go-live',
      },
      bars: {
        requirements: 'Levantamento',
        design: 'Desenho da solução',
        setup: 'Configuração',
        migration: 'Migração de dados',
        uat: 'Homologação',
        training: 'Treinamento',
      },
    },
    kanban: {
      aria: 'MeuGantt: quadro Kanban com card sendo arrastado entre colunas',
      taskCount: '6 tarefas',
      sprint: 'Sprint 2: Execução',
      columns: ['A fazer', 'Em andamento', 'Concluído'],
      cards: [
        { title: 'Plano de cutover', desc: 'Sequência de virada e rollback' },
        { title: 'Treinamento dos usuários', desc: 'Material e agenda das turmas' },
        { title: 'Integração com ERP', desc: 'Homologar payloads do fornecedor' },
        { title: 'Kickoff do projeto', desc: 'Ata e matriz de responsabilidades' },
        { title: 'Status report semanal', desc: 'Farol, riscos e próximos passos' },
      ],
    },
    portfolio: {
      aria: 'MeuGantt: portfólio executivo com KPIs consolidados e Curva S de Earned Value',
      tabs: ['Visão Geral', 'Projetos', 'Equipe'],
      kpis: ['Projetos', 'Progresso Médio', 'Utilização · 6 recursos', 'Orçamento Total'],
      evm: ['PV · Planejado', 'EV · Agregado', 'AC · Real', 'EAC · Forecast'],
      curveTitle: 'Curva S · Earned Value',
      curveSubtitle: 'Acumulado semanal · PV × EV × AC · EAC = forecast',
    },
    capacity: {
      aria: 'MeuGantt: capacidade da equipe com plano por recurso e alerta de overbooking',
      tabs: ['Visão Geral', 'Projetos', 'Equipe'],
      periods: ['Semana', 'Mês', 'Trimestre'],
      attentionTitle: 'Atenção Necessária',
      plan: 'Plano',
      available: 'Disponível',
      chipAttention: 'Atenção',
      chipOverbooking: 'Overbooking',
      free: 'LIVRE',
      over: 'EXCESSO',
      roles: ['UX Designer', 'Tech Lead', 'Back-End Dev', 'Dev Mobile'],
    },
      chrome: {
        appTitle: 'Portfólio de Projetos',
        simulate: 'Simular Projeto',
        manageResources: 'Gerenciar Recursos',
        live: 'Ao vivo',
        filters: 'Filtros',
        critical: 'Crítico',
        today: 'Hoje',
        months: ['abr', 'mai', 'jun', 'jul'],
        spi: 'SPI 0,94',
        cpi: 'CPI 1,02',
        colCapacity: 'CAPACIDADE',
        colPlan: 'PLANO',
      },
      claudeChrome: {
        newChat: 'Nova conversa',
        recent: 'Recentes',
        threads: ['Sprint Q2: Lançamento', 'Brief executivo Maio', 'Riscos projeto Pulsar'],
        userRole: 'Gerente de Projetos',
        plan: 'Claude Pro',
        connected: 'MeuGantt conectado',
        viaMcp: 'via MeuGantt MCP',
        running: 'Executando…',
      },
    claude: {
      aria: 'MeuGantt conectado ao Claude via MCP: tarefas criadas por conversa em linguagem natural',
      prompt: 'Adiciona 5 tarefas no projeto Lançamento Q2 com dependências em cascata e prazos a partir de segunda-feira.',
      toolResult: '5 tarefas criadas: Pesquisa (3d) → Design (5d) → Dev Backend (8d) → Dev Frontend (8d, paralelo) → Go-live (1d)',
      answer: 'Pronto. Caminho crítico: Pesquisa → Design → Backend → Go-live, 17 dias úteis. Quer que eu salve a baseline e aloque os responsáveis?',
      caption: 'Peça pro Claude operar seus projetos no MeuGantt',
    },
  },

  footer: {
    tagline: 'Gestão de projetos visual e intuitiva.',
    product: 'Produto',
    legal: 'Legal',
    social: 'Social',
    privacy: 'Política de Privacidade',
    terms: 'Termos de Uso',
  },
};

export default landing;

/** en e es são tipados por esta forma: chave faltando vira erro de compilação. */
export type LandingCopy = typeof landing;
